import { render, staticRenderFns } from "./OphthalmologicalAttention.vue?vue&type=template&id=4e376f89&"
import script from "./OphthalmologicalAttention.vue?vue&type=script&lang=js&"
export * from "./OphthalmologicalAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYTransition})
